import { Menu } from 'antd'
import { useEffect, useState } from 'react'

const getAllSubmenuKeys = (items: any[]): string[] =>
  (items || []).flatMap((item) =>
    item?.children ? [item.key, ...getAllSubmenuKeys(item.children)] : []
  )

const MenuLeft = ({ onChange, selectedKey, menu, collapsemenu }: any) => {
  const [openKeys, setOpenKeys] = useState<string[]>([])
  const [initialized, setInitialized] = useState(false)

  useEffect(() => {
    if (menu?.length && !initialized) {
      setOpenKeys(getAllSubmenuKeys(menu))
      setInitialized(true)
    }
  }, [menu, initialized])

  const onOpenChange = (keys: string[]) => {
    setOpenKeys(keys)
  }

  return (
    <Menu
      onClick={onChange}
      selectedKeys={selectedKey}
      mode="inline"
      openKeys={collapsemenu ? [] : openKeys}
      onOpenChange={onOpenChange}
      items={menu}
      className="menu-antd-user"
      theme="light"
      inlineCollapsed={collapsemenu}
    />
  )
}

export default MenuLeft
